<template>
  <div class="audio-progress-bar">
    <input
      type="range"
      :style="{ background: rangeInputBg }"
      :value="value"
      :min="0"
      :max="100"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    rangeInputBg: {
      type: String,
      default: 'inherit',
    },
  },
  emits: ['input', 'change'],
}
</script>

<style lang="scss" scoped>
.audio-progress-bar {
  margin-top: 8px;
  line-height: 4px;
}

input {
  appearance: none;
  border-radius: 4px;
  cursor: pointer;
  height: 4px;
  width: 100%;
}

input::-webkit-slider-runnable-track,
input::-moz-range-track {
  height: 100%;
  width: 100%;
}

input::-webkit-slider-thumb {
  appearance: none;
  border: 0;
  width: 0;
  height: 0;
}

input::-moz-range-thumb {
  border: 0;
  width: 0;
  height: 0;
}
</style>
